import { render, staticRenderFns } from "./HotelOrderCard.vue?vue&type=template&id=6c4f4b0a"
import script from "./HotelOrderCard.vue?vue&type=script&lang=js"
export * from "./HotelOrderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports